import { ArrowBack, Close } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Header } from '../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../components/layout/main/mainStyles';
import { RightSideBar } from '../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../constants/sidebarEnums';
import Strings from '../../i18n';
import { ContainerTable } from '../../templates/locations/locationsList/locationListStyles';
import { ButtonIconStyled } from '../devices/devicesStyles';
import { TooltipStyled } from '../locations/locationStyles';
import { EffectStoreListTable } from '../../templates/store/effectsStore/effectStoreListTable/effectStoreListTable';
import { IEffectItemStore } from '../../types/effects/effectsStoreInterface';
import { useGetEffectsListByLocationMutation } from '../../services/effects/effectsStoreService';

export const EffectsByLocationView = () => {
  const { locationId } = useParams();
  const navigate = useNavigate();
  const [selectedEffects, setSelectedEffects] = useState<IEffectItemStore[]>(
    []
  );
  const [openSideBar, setOpenSideBar] = useState(false);

  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.empty
  );

  const [paginator, setPaginator] = useState({
    currentPage: 1,
    pageSize: 250
  });

  const [getEffectsStoreList, { data }] = useGetEffectsListByLocationMutation();

  const openRightSideBarForMethod = (value: viewRightSideBarEnum) => {
    setSideBarOpenFor(value);
    setOpenSideBar(true);
  };

  const closeSideBar = () => {
    setOpenSideBar(false);
  };
  const switchComponentToShowRightSideBar = () => {
    return <div>EffectsByLocationView</div>;
  };

  const reloadTable = () => {
    getEffectsStoreList({ locationId: parseInt(locationId || '0', 10) });
  };

  useEffect(() => {
    getEffectsStoreList({ locationId: parseInt(locationId || '0', 10) });
  }, [locationId]);

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between align-items-center">
            <div className="col-1 col-sm-4 text-left">
              <ButtonIconStyled
                onClick={() => {
                  navigate(`/locations/${locationId}/applications`);
                }}
              >
                <ArrowBack />
              </ButtonIconStyled>
            </div>
            <div className="col-6 col-sm-4 text-center">
              <StyledTitleHeader align="center" className="mb-0">
                {Strings.effects.effectsByLocation.title}
              </StyledTitleHeader>
            </div>
            <div className="col-5 col-sm-4 text-right">
              <Tooltip
                title={Strings.locations.effectWithVideo}
                placement="top"
                arrow
                componentsProps={TooltipStyled}
              >
                <ButtonIconStyled onClick={() => {}}>
                  <Close />
                </ButtonIconStyled>
              </Tooltip>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <ContainerTable component="main">
        <EffectStoreListTable
          reloadTable={reloadTable}
          selectedEffects={selectedEffects}
          setSelectedEffects={setSelectedEffects}
          data={data || []}
          totalEffects={data?.length || 0}
          paginator={paginator}
          setPaginator={(value) => setPaginator(value)}
          withLocation
        />
      </ContainerTable>
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          closeSideBar();
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
    </>
  );
};
